import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="ct_policy_page">
      <div className="ct_policy_container">
        <div className="ct_policy_header">
          <div style={{ marginBottom: "20px" }}>
            <img src="/img/Logo_blue_new.png" alt="First Mate Logo" style={{ height: "70px", objectFit: "contain" }} />
          </div>
          <h1 className="ct_policy_title">PRIVACY POLICY &amp; DATA PROCESSING TERMS</h1>
          <p className="ct_policy_meta">
            Schedule C · Version 1.0 · Effective Date: 14/07/2026
          </p>
          <div style={{ fontSize: "13px", color: "#64748b", marginTop: "5px" }}>
            <strong>Issued By:</strong> First Mate Pty Ltd (ABN: 52 662 331 713), Queensland, Australia
          </div>
        </div>
        <div className="ct_policy_content">
          <p>
            This Privacy Policy and Data Processing Terms ("Privacy Policy") forms part of the Servicehub Software Services Agreement between First Mate Pty Ltd ("First Mate", "we", "our", "us") and the Provider.
          </p>
          <p>
            This Policy explains how information is collected, used, stored, disclosed and protected when using Servicehub and any related First Mate products and services.
          </p>

          <h3>1. PURPOSE</h3>
          <p>
            Servicehub is designed to assist businesses in managing maintenance, service delivery, warranty administration, customer communications, asset records and digital service histories.
          </p>
          <p>
            To provide these services, First Mate may collect, process and store information relating to Providers, Customers, vessels, assets, equipment and service activities.
          </p>

          <h3>2. APPLICATION</h3>
          <p>This Privacy Policy applies to:</p>
          <ul>
            <li>Servicehub software users;</li>
            <li>Business account holders;</li>
            <li>Employees and contractors of Providers;</li>
            <li>Customers whose information is entered into Servicehub;</li>
            <li>Users of connected First Mate ecosystem services.</li>
          </ul>

          <h3>3. INFORMATION WE COLLECT</h3>
          <p>Information collected may include:</p>

          <p><strong>Business Information:</strong></p>
          <ul>
            <li>Business name</li>
            <li>ABN or registration details</li>
            <li>Business address</li>
            <li>Contact details</li>
            <li>Billing information</li>
          </ul>

          <p><strong>User Information:</strong></p>
          <ul>
            <li>Names</li>
            <li>Email addresses</li>
            <li>Phone numbers</li>
            <li>User roles</li>
            <li>Login activity</li>
          </ul>

          <p><strong>Customer Information:</strong></p>
          <ul>
            <li>Customer names</li>
            <li>Contact details</li>
            <li>Vessel ownership information</li>
            <li>Asset ownership information</li>
            <li>Service history information</li>
          </ul>

          <p><strong>Asset Information:</strong></p>
          <ul>
            <li>Vessel details</li>
            <li>Engine details</li>
            <li>Equipment records</li>
            <li>Serial numbers</li>
            <li>Warranty information</li>
            <li>Maintenance schedules</li>
          </ul>

          <p><strong>Operational Information:</strong></p>
          <ul>
            <li>Job records</li>
            <li>Service reports</li>
            <li>Inspection reports</li>
            <li>Warranty claims</li>
            <li>Maintenance requests</li>
            <li>Uploaded photographs</li>
            <li>Uploaded documents</li>
          </ul>

          <p><strong>Technical Information:</strong></p>
          <ul>
            <li>IP addresses</li>
            <li>Browser information</li>
            <li>Device information</li>
            <li>Usage analytics</li>
            <li>Error logs</li>
          </ul>

          <h3>4. HOW INFORMATION IS COLLECTED</h3>
          <p>Information may be collected when:</p>
          <ul>
            <li>Accounts are created;</li>
            <li>Data is entered into the Platform;</li>
            <li>Customers submit forms;</li>
            <li>Warranty requests are lodged;</li>
            <li>Maintenance requests are submitted;</li>
            <li>Documents are uploaded;</li>
            <li>Users contact support;</li>
            <li>Platform analytics are generated.</li>
          </ul>

          <h3>5. PURPOSE OF COLLECTION</h3>
          <p>Information may be collected and processed for the purpose of:</p>
          <ul>
            <li>Delivering Servicehub services;</li>
            <li>Managing subscriptions;</li>
            <li>Creating service records;</li>
            <li>Facilitating customer communications;</li>
            <li>Maintaining digital logbooks;</li>
            <li>Supporting warranty administration;</li>
            <li>Providing technical support;</li>
            <li>Improving Platform performance;</li>
            <li>Developing future functionality;</li>
            <li>Meeting legal obligations.</li>
          </ul>

          <h3>6. INFORMATION SHARING</h3>
          <p>First Mate does not sell personal information. Information may be disclosed:</p>
          <p><strong>To the Provider:</strong> To allow the Provider to perform maintenance, warranty and customer service activities.</p>
          <p><strong>To Connected Customers:</strong> Where approved integrations exist, information may be shared with vessel owners through the First Mate application (e.g. service records, maintenance schedules, warranty info, inspection reports, asset histories).</p>
          <p><strong>To Service Providers:</strong> Third-party hosting, cloud, security and support providers may process information on behalf of First Mate. First Mate will maintain a current list of approved sub-processors and will provide the Provider with at least thirty (30) days’ prior written notice before engaging any new sub-processor. All sub-processors will be bound by data protection obligations no less stringent than those set out in this Privacy Policy.</p>
          <p><strong>Legal Requirements:</strong> Information may be disclosed where required by court order, law enforcement request, regulatory authority, or legal obligation.</p>

          <h3>7. DATA PROCESSING ROLE</h3>
          <p>For information entered by a Provider:</p>
          <ul>
            <li>The Provider is generally the Data Controller.</li>
            <li>First Mate acts as a Data Processor.</li>
          </ul>
          <p>The Provider remains responsible for: obtaining required consents, ensuring lawful collection, ensuring data accuracy, and managing customer privacy obligations.</p>
          <p>As Data Processor, First Mate shall:</p>
          <ul>
            <li>process Provider data only in accordance with documented instructions from the Provider;</li>
            <li>ensure that all persons authorised to process Provider data are bound by appropriate confidentiality obligations;</li>
            <li>not engage sub-processors to process Provider data without prior written consent of the Provider;</li>
            <li>assist the Provider in responding to requests from individuals exercising their privacy rights under applicable law;</li>
            <li>on termination of the Agreement, delete or return all Provider data in accordance with the data retention provisions of this Privacy Policy; and</li>
            <li>make available to the Provider, on reasonable request, such information as is reasonably necessary to demonstrate First Mate’s compliance with its obligations under this Privacy Policy.</li>
          </ul>

          <h3>8. DATA SECURITY</h3>
          <p>First Mate uses reasonable technical and organisational measures to protect information, consistent with industry standards applicable to SaaS platform providers. Security measures may include encrypted data transmission, secure cloud infrastructure, access controls, user authentication, system monitoring, and backup systems.</p>
          <p>No internet-based service can guarantee absolute security.</p>
          <p>In the event of a confirmed security incident affecting Provider data, First Mate will notify the affected Provider in writing within 72 hours of becoming aware of the incident, including reasonable details of the nature, scope and likely impact of the incident and the steps First Mate is taking to address it.</p>

          <h3>9. DATA STORAGE</h3>
          <p>Information may be stored within Australia, within approved cloud infrastructure providers, or within secure backup systems.</p>
          <p>Providers acknowledge that data may be processed using international cloud infrastructure where necessary to deliver the Platform. Where data is transferred to or processed in a jurisdiction outside Australia, First Mate will ensure that the recipient is subject to privacy protections that are at least equivalent to the Australian Privacy Principles, or that the transfer otherwise complies with the requirements of the Privacy Act 1988 (Cth), including APP 8.</p>

          <h3>10. DATA RETENTION</h3>
          <p>Information is retained for as long as reasonably necessary to provide services, meet legal obligations, resolve disputes, and enforce agreements.</p>
          <p>Following account termination:</p>
          <ul>
            <li>Data will remain available for thirty (30) days for export;</li>
            <li>Archived backups will be deleted within ninety (90) days of account termination;</li>
            <li>All remaining data will be permanently deleted following expiry of the applicable retention period, unless retention is required by applicable law, in which case First Mate will notify the Provider and retain only the minimum data required.</li>
          </ul>

          <h3>11. CUSTOMER ACCESS AND CORRECTION</h3>
          <p>Providers are responsible for updating customer information maintained within Servicehub.</p>
          <p>Individuals seeking access to or correction of their information should first contact the Provider responsible for the information. First Mate may assist Providers in responding to such requests where appropriate.</p>

          <h3>12. ANALYTICS AND PLATFORM IMPROVEMENT</h3>
          <p>First Mate may collect aggregated and de-identified information for platform performance analysis, feature development, product improvement, usage reporting, and statistical analysis.</p>
          <p>Such information will not identify individual customers or the Provider’s business operations, and will not be commercialised in a manner detrimental to the Provider or used for the benefit of any competitor of the Provider.</p>

          <h3>13. MARKETING COMMUNICATIONS</h3>
          <p>Business contact information may be used to provide service updates, announce new features, deliver important account notices, and provide product information.</p>
          <p>Recipients may unsubscribe from marketing communications at any time. Service-related communications may continue where necessary for account administration.</p>

          <h3>14. DATA BREACHES</h3>
          <p>Where First Mate becomes aware of a data breach likely to result in serious harm, First Mate will notify affected Providers in writing within 72 hours of becoming aware of the breach and will: investigate the incident, take reasonable steps to contain the breach, notify affected Providers where required, and comply with applicable legal obligations.</p>
          <p>Providers remain responsible for breaches arising from their own systems, personnel or security practices.</p>
          <p>First Mate remains responsible for data breaches arising from its own infrastructure, systems, personnel or security failures, and will indemnify the Provider against reasonable costs and losses incurred as a result of any such breach.</p>

          <h3>15. THIRD-PARTY SERVICES</h3>
          <p>Servicehub may integrate with third-party systems including accounting software, payment providers, email providers, cloud storage services, First Mate applications, or other future approved integrations.</p>
          <p>Use of third-party services may be subject to separate terms and privacy policies.</p>

          <h3>16. INTERNATIONAL USERS</h3>
          <p>Providers operating outside Australia acknowledge that information may be processed in Australia or other jurisdictions used by approved infrastructure providers. By using Servicehub, Providers consent to such processing.</p>

          <h3>17. CHANGES TO THIS POLICY</h3>
          <p>First Mate may update this Privacy Policy from time to time, provided that any material changes will be notified to Providers in writing at least thirty (30) days before taking effect.</p>
          <p>Updated versions will be published through the Platform and website.</p>
          <p>If a Provider objects to any material change to this Privacy Policy, the Provider may terminate its account prior to the change taking effect without penalty. Continued use of Servicehub following the expiry of the notice period constitutes acceptance of the revised policy.</p>

          <h3>18. CONTACT DETAILS</h3>
          <p>Privacy enquiries, complaints or requests may be directed to:</p>
          <p>
            Privacy Officer<br />
            First Mate Pty Ltd<br />
            Email: ahoy@firstmate.com.au<br />
            Website: www.firstmate.com.au
          </p>

          <h3>19. ACKNOWLEDGEMENT</h3>
          <p>By accessing or using Servicehub, the Provider acknowledges that it has read, understood and agrees to this Privacy Policy and Data Processing Terms.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
